/**
 * OfferDeadlineDisclaimer — the legal disclaimer shown next to every offer
 * acceptance-deadline field (offer wizard, counter modal, negotiation
 * workspace). It is a callout at body size, never fine print: buyers and
 * sellers must be able to read it before they set a deadline.
 */
import React from 'react';
import { OFFER_DEADLINE_DISCLAIMER } from '../../utils/disclaimers';
import styles from './OfferDeadlineDisclaimer.module.css';

export default function OfferDeadlineDisclaimer() {
  return (
    <p className={styles.disclaimer} role="note" data-testid="offer-deadline-disclaimer">
      {OFFER_DEADLINE_DISCLAIMER}
    </p>
  );
}
